// extracted by mini-css-extract-plugin
module.exports = {"imageSlider":"HomeBanner_imageSlider__MVx4F","HomeBanner":"HomeBanner_HomeBanner__3VWJF"};